<template>
  <div class="section03">
    <div class="headerprocess" style="text-align: center">
      รวมทุกค่ายเกมส์ไว้ที่เดียว
    </div>
    <div class="px-2">
      <div class="row m-0 mt-2 mt-md-3">
        <div class="col-12 col-sm-12 p-0 px-md-3">
          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane fade show active"
              id="pills-Casino"
              role="tabpanel"
              aria-labelledby="pills-Casino-tab"
            >
              <div class="containslide2 gslidebg" :style="{ backgroundImage: createBackgroundString }">
                <div class="swiper gameslide casinossw">
                  <swiper class="swiper" :options="swiperOptions">
                    <swiper-slide
                      class="slide"
                      v-for="(provider, index) in Providers"
                      :key="index"
                      ><img :src="provider.logo" alt="Slide Provider"
                    /></swiper-slide>
                  </swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="x-hr-border-glow my-2 mt-3" />
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { mapGetters } from "vuex";

export default {
  name: "providerlide-component",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      swiperOptions: {
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        loopFillGroupWithBlank: true,
      },
    };
  },
  computed: {
    ...mapGetters(["Providers"]),
    ...mapGetters(["WebSetting"]),
    createBackgroundString() {
      return `linear-gradient(145deg, ${this.WebSetting.color1}, #000000d4)`;
    }
  },
};
</script>

<style></style>
